<template>
  <div>
    <breadcrumbs home="Customer"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">

          <v-tabs class="full-height-tab" show-arrows>
            <v-tab>Info</v-tab>
            <v-tab-item>
              <v-container class="pt-6 px-6" fluid>
                <v-row dense>
                  <v-col cols="12" sm="5">
                    <v-text-field label="Name" v-model="customer.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="2" md="1">
                    <v-checkbox label="Active" v-model="customer.active" class="mt-1"/>
                  </v-col>
                  <v-col v-if="$store.getters.company.province==='BC'" cols="2" md="1" class="mt-1">
                    <lookup-licensee-button :customer="customer"/>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <inventory-categories-select v-model="customer.categoryId" label="Category" type="Customer" allow-add hint/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="6" sm="3" lg="2">
                    <v-checkbox label="Is sub-customer" v-model="isSubCustomer" class="mt-1" @change="dirty=true;getCustomers()"/>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-autocomplete v-model="customer.parentId" outlined dense label="Parent customer" :disabled="!isSubCustomer"
                                    :items="customers" item-text="name" item-value="id"/>
                  </v-col>
                  <v-col cols="6" sm="3" lg="2">
                    <v-checkbox label="Bill with parent" v-model="customer.billWithParent" class="mt-1" :disabled="!isSubCustomer"/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12" sm="5">
                    <v-text-field label="Email" v-model="customer.email" :rules="[fieldRules.maxLength(100),fieldRules.email]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6" sm="3">
                    <v-text-field label="Phone" v-model="customer.phone" :rules="[fieldRules.maxLength(20),fieldRules.phone]" :counter="20" outlined dense/>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="7" sm="3">
                    <v-autocomplete v-model="customer.type" outlined dense label="Type" :items="types"
                                    append-outer-icon="mdi-help-circle"
                                    @click:append-outer="$store.dispatch('help', {title:'Creating and editing customers',topicId:'RgAEAAAA',articleId:'RwAsAAAA',ref:'types'})"/>
                  </v-col>
                  <v-col cols="5" sm="2">
                    <v-text-field v-if="customer.type!=='None'" v-model="customer.license" outlined dense label="License number" :rules="[fieldRules.maxLength(20)]" :counter="20"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6" sm="2" v-if="multiCurrency">
                    <v-autocomplete v-model="customer.currency" outlined dense label="Currency" :disabled="customerId!=undefined"
                                    :items="currencies" item-text="code" item-value="code"/>
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-autocomplete v-model="customer.termId" outlined dense label="Terms"
                                    :items="terms" item-text="name" item-value="id"/>
                  </v-col>
                </v-row>
                <v-row dense v-if="salesReps.length > 1">
                   <v-col cols="12" sm="5">
                    <v-autocomplete v-model="customer.salesRepId" outlined dense label="Sales representative" :disabled="!!restrictedToSalesRep"
                                    :items="salesReps" item-text="name" item-value="id"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="6">
                    <v-text-field label="Notes" v-model="customer.notes" outlined dense :rules="[fieldRules.maxLength(200)]" :counter="200"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab>Billing</v-tab>
            <v-tab-item>
              <v-container class="pt-6 px-6" fluid>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 1" v-model="customer.billingAddress.line1" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 2" v-model="customer.billingAddress.line2" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="8" sm="3">
                    <v-text-field label="City" v-model="customer.billingAddress.city" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="4" sm="1">
                    <v-text-field label="Province" v-model="customer.billingAddress.province" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
                  </v-col>
                  <v-col cols="4" sm="2">
                    <v-text-field label="Postal code" v-model="customer.billingAddress.postalCode" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab>Shipping</v-tab>
            <v-tab-item>
              <v-container class="pt-6 px-6" fluid>
                <v-row dense>
                  <v-col cols="8" sm="4" lg="2">
                    <v-checkbox label="Use billing address" v-model="useBilling" dense class="mt-n1" @change="copyBilling"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 1" v-model="customer.shippingAddress.line1" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense :disabled="useBilling"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Line 2" v-model="customer.shippingAddress.line2" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense :disabled="useBilling"/>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="8" sm="3">
                    <v-text-field label="City" v-model="customer.shippingAddress.city" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense :disabled="useBilling"/>
                  </v-col>
                  <v-col cols="4" sm="1">
                    <v-text-field label="Province" v-model="customer.shippingAddress.province" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense :disabled="useBilling"/>
                  </v-col>
                  <v-col cols="4" sm="2">
                    <v-text-field label="Postal code" v-model="customer.shippingAddress.postalCode" :rules="[fieldRules.maxLength(20)]" :counter="20" outlined dense :disabled="useBilling"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" sm="3" md="2">
                    <shipment-zones-select v-model="customer.shipmentZoneId" label="Shipment zone" allow-add/>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>

            <v-tab>Contacts</v-tab>
            <v-tab-item>
              <contacts :contacts="customer.contacts" @validate="$nextTick(() => $refs.form.validate())"/>
            </v-tab-item>
          </v-tabs>
        </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'
import customerTypes from '@/mixins/customerTypes'
import Contacts from '@/views/sales/customers/Contacts'
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'
import ShipmentZonesSelect from '@/views/sales/shipmentZones/SalesShipmentZonesSelect'
import LookupLicenseeButton from '@/views/provinces/BC/sales/LookupLicenseeButton'

export default {
  name: 'SalesCustomersEdit',
  mixins: [confirmLeave,customerTypes],
  components: {Contacts,InventoryCategoriesSelect,LookupLicenseeButton,ShipmentZonesSelect},
  props: {
    customerId: {type:String, required:false}
  },
   data () {
    return {
      tab: null,
      isSubCustomer: false,
      customers: [],
      types: [],
      useBilling: false,
      customer: {name:'',active:true,billWithParent:false,categoryId:null,
                 shippingAddress: {line1:'',line2:'',city:'',province:'',postalCode:'',country:''},
                 billingAddress: {line1:'',line2:'',city:'',province:'',postalCode:'',country:''},
                 phone:'',email:'',currency:'',termId:'',salesRepId:'',
                 type:'None',license:'',contacts:[],notes:'',shipmentZoneId:''},
      currencies: [],
      terms: [{id:'',name:''}],
      salesReps: [{id:'',name:''}],
      restrictedToSalesRep: '',
      dirty: false,
      valid: true,
      saving: false,
      loading: true
    }
  },
  computed: {
    multiCurrency() {
      return this.$store.getters.company.settings.multiCurrency;
    },
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  watch: {
    customer: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    await this.$lazyListLoad(this.salesReps, 'salesReps2', 'id,name,restricted,userId', 100, [{field:'active', comparator:'eq', value:'true'}])
    this.$lazyListLoad(this.terms, 'terms2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])

    const results = await this.$apiCall(`query SalesCustomersEdit($id:ID!, $edit:Boolean!, $multiCurrency:Boolean!) {
                                              company @include(if:$multiCurrency) {
                                                currencies {code}
                                              }
                                              customer(id:$id) @include(if:$edit) {
                                                id,parent{id},billWithParent,
                                                category{id}
                                                name,active,type,license,
                                                email,phone,currency,term {id}, salesRep {id}
                                                shippingAddress {line1,line2,city,province,postalCode,country},
                                                billingAddress {line1,line2,city,province,postalCode,country}
                                                contacts {name,title,email,phone}
                                                shipmentZone{id}
                                                notes
                                              }
                                            }`,
                                        {id:this.customerId||'',edit:this.customerId!=undefined,multiCurrency:this.multiCurrency});
    if (results.error) {
      this.$nextTick(() => this.dirty = false);
      this.$router.back();
      return
    }
    this.currencies = [{code:this.$store.getters.company.settings.homeCurrency}];
    if (this.multiCurrency)
      this.currencies = this.currencies.concat(results.data.company.currencies);
    this.restrictedToSalesRep = this.salesReps.find(rep => rep.userId === this.$store.state.user.sub && rep.restricted)?.id || '';
    if (this.customerId) {
      this.customer = {...results.data.customer,
                       termId:results.data.customer.term?.id, term:undefined,
                       shipmentZoneId:results.data.customer.shipmentZone?.id, shipmentZone:undefined,
                       salesRepId:results.data.customer.salesRep?.id, salesRep:undefined,
                       categoryId:results.data.customer.category?.id,category:undefined,
                       parentId:results.data.customer.parent?.id, parent:undefined};
      this.isSubCustomer = this.customer.parentId ? true : false;
      if (this.isSubCustomer)
        await this.getCustomers();
    }

    if (!this.customerId) {
      this.customer.currency = this.currencies[0].code;
      this.customer.salesRepId = this.restrictedToSalesRep;
      this.$nextTick(() => this.$refs.form.validate());
    }
    this.types = await this.buildCustomerTypes();

    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    async getCustomers() {
      if (this.customers.length === 0) {
        this.customers = await this.$store.dispatch('customers', false);
        this.customers.splice(this.customers.findIndex(customer => customer.id === this.customerId), 1);
        if (!this.customer.parentId)
          this.customer.parentId = this.customers[0].id;
      }
    },
    copyBilling() {
      if (this.useBilling)
        Object.assign(this.customer.shippingAddress, this.customer.billingAddress);
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = {...this.customer};
      if (!this.isSubCustomer)
        input.parentId = null;
      if (this.customerId)
        delete input.currency;
      const results = await this.$store.dispatch('customerCreate', input);
      this.saving = false;
      if (!results.error)
        this.$nextTick(() => {
          this.dirty = false;
          this.$router.back();
          this.$store.commit('setError', {type:'success',message:`${this.customerId?'Updated':'Created'} customer ${this.customer.name}`});
        });
    }
  }
}
</script>